module.exports = __webpack_public_path__ + "img/madera0.bb6a4e9e.jpg";